"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maxAgeValidator = exports.mapOptionsToValues = exports.isDateBeforeToday = exports.getOptionsSchema = exports.getOptionKey = exports.getIsPassportExpireDateValidator = exports.generateOptionsValidators = exports.createValidationsSchemaByExternalPassportFields = exports.createPassportTouchedEntity = exports.createChildPassport = exports.birthdayValidator = void 0;
var _moment = _interopRequireDefault(require("moment"));
var R = _interopRequireWildcard(require("ramda"));
var _yup = require("yup");
var _localization = _interopRequireDefault(require("../../../../../../localization"));
var _fn = require("../../../../../../helpers/fn");
var _constants = require("../../constants");
var _constants2 = require("./constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var createMoment = function createMoment(stringDate) {
  return (0, _moment.default)(stringDate, _constants.DATE_FORMAT, true);
};
var isValidDate = function isValidDate(stringDate) {
  return createMoment(stringDate).isValid();
};
var isAgeInRange = function isAgeInRange(age, _ref) {
  var from = _ref.from,
    to = _ref.to;
  return age >= from && age <= to;
};
var getValidateRange = function getValidateRange(offer, index) {
  return offer.people.childrenAgesRange[index - offer.people.adults];
};
var isDateBeforeToday = exports.isDateBeforeToday = R.ifElse(isValidDate, function (stringDate) {
  return createMoment(stringDate).isBefore((0, _moment.default)().startOf('day'));
}, R.F);
var getIsPassportExpireDateValidator = exports.getIsPassportExpireDateValidator = function getIsPassportExpireDateValidator(_ref2) {
  var expireDate = _ref2.expireDate,
    startTourDate = _ref2.startTourDate,
    _ref2$months = _ref2.months,
    months = _ref2$months === void 0 ? 0 : _ref2$months,
    _ref2$nights = _ref2.nights,
    nights = _ref2$nights === void 0 ? 0 : _ref2$nights;
  return R.ifElse(isValidDate, function (stringDate) {
    var returnDate = (0, _moment.default)(startTourDate, 'YYYY-MM-DD').startOf('day').add(nights, 'days').add(months, 'months');
    return !createMoment(stringDate).isBefore(returnDate);
  }, R.F)(expireDate);
};
var birthdayValidator = exports.birthdayValidator = function birthdayValidator(date, _ref3, offer) {
  var index = _ref3.options.index;
  return R.ifElse(isDateBeforeToday, R.ifElse(function (_, validateRange) {
    return validateRange;
  }, function (stringDate, validateRange) {
    var returnDate = (0, _moment.default)(offer.date, 'YYYY-MM-DD').startOf('day').add(offer.nights, 'days');
    return isAgeInRange(returnDate.diff(createMoment(stringDate), 'years'), validateRange);
  }, R.T), R.F)(date, getValidateRange(offer, index));
};
var MAX_AGE = 99;
var maxAgeValidator = exports.maxAgeValidator = R.ifElse(isDateBeforeToday, function (stringDate) {
  var birthDate = createMoment(stringDate);
  return (0, _moment.default)().diff(birthDate, 'years') <= MAX_AGE;
}, R.F);
var createChildPassport = exports.createChildPassport = function createChildPassport(passport) {
  return R.mergeAll([passport, {
    sex: _constants2.SEX_TYPES.CHILD.value
  }]);
};
var checkboxValidationSchema = function checkboxValidationSchema(isRequire) {
  var checkboxBaseSchema = (0, _yup.bool)();
  return isRequire ? checkboxBaseSchema.oneOf([true], _localization.default.t('VALIDATION_ERRORS:REQUIRED_FIELD')) : checkboxBaseSchema;
};
var textValidationSchema = function textValidationSchema(isRequire) {
  var textBaseSchema = (0, _yup.string)()
  // eslint-disable-next-line no-useless-escape
  .matches(/^[^а-яА-ЯЁё]+$/, _localization.default.t('VALIDATION_ERRORS:INVALID_CHARACTERS'));
  return isRequire ? textBaseSchema.required(_localization.default.t('VALIDATION_ERRORS:REQUIRED_FIELD')) : textBaseSchema;
};
var createValidationsSchemaByExternalPassportFields = exports.createValidationsSchemaByExternalPassportFields = function createValidationsSchemaByExternalPassportFields(fieldsAsMap) {
  return R.map(function (_ref4) {
    var validations = _ref4.validations;
    var schema = (0, _yup.string)();
    var setValidationToSchema = R.cond([[R.equals('required'), function () {
      schema = schema.required(_localization.default.t('VALIDATION_ERRORS:REQUIRED_FIELD'));
    }], [R.equals('cyrillicAndStandardChars'), function () {
      schema = schema.matches(/^[А-Яа-яЁёІіЇїЙйҐґЄє\s.,-]+$/, _localization.default.t('VALIDATION_ERRORS:INVALID_CHARACTERS'));
    }], [R.equals('invalid_characters'), function () {
      schema = schema.matches(/[0-9]/, _localization.default.t('VALIDATION_ERRORS:INVALID_CHARACTERS')).min(10, _localization.default.t('VALIDATION_ERRORS:INVALID_FIELD_LENGTH', {
        length: 10,
        symbolWord: (0, _fn.declension)(10, [_localization.default.t('SYMBOLS:ONE_SYMBOL'), _localization.default.t('SYMBOLS:SOME_SYMBOLS'), _localization.default.t('SYMBOLS:MANY_SYMBOLS')])
      })).max(12, _localization.default.t('VALIDATION_ERRORS:INVALID_FIELD_LENGTH', {
        length: 12,
        symbolWord: (0, _fn.declension)(12, [_localization.default.t('SYMBOLS:ONE_SYMBOL'), _localization.default.t('SYMBOLS:SOME_SYMBOLS'), _localization.default.t('SYMBOLS:MANY_SYMBOLS')])
      }));
    }], [R.T, function (validation) {
      return console.log("".concat(validation, " is not supported"));
    }]]);
    validations.forEach(setValidationToSchema);
    return schema;
  }, fieldsAsMap);
};
var emailValidationSchema = function emailValidationSchema(isRequire) {
  var emailBaseSchema = (0, _yup.string)().email(_localization.default.t('VALIDATION_ERRORS:NOT_CORRECT_EMAIL'));
  return isRequire ? emailBaseSchema.required(_localization.default.t('VALIDATION_ERRORS:REQUIRED_FIELD')) : emailBaseSchema;
};
var dateValidationSchema = function dateValidationSchema(isRequire) {
  var dateBaseSchema = (0, _yup.string)().test('passportGivenDate', _localization.default.t('VALIDATION_ERRORS:INVALID_DATE'), isValidDate);
  return isRequire ? dateBaseSchema.required(_localization.default.t('VALIDATION_ERRORS:REQUIRED_FIELD')) : dateBaseSchema;
};
var phoneValidationSchema = function phoneValidationSchema(isRequire) {
  var phoneBaseSchema = (0, _yup.string)().matches(_constants2.PHONE_VALIDATION_MASK, _localization.default.t('VALIDATION_ERRORS:INVALID_PHONE_NUMBER'));
  return isRequire ? phoneBaseSchema.required(_localization.default.t('VALIDATION_ERRORS:REQUIRED_FIELD')) : phoneBaseSchema;
};
var OPTIONS_CONTROLS_VALIDATORS = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _constants.OPTIONS_CONTROLS_TYPES.CHECKBOX, checkboxValidationSchema), _constants.OPTIONS_CONTROLS_TYPES.TEXT, textValidationSchema), _constants.OPTIONS_CONTROLS_TYPES.EMAIL, emailValidationSchema), _constants.OPTIONS_CONTROLS_TYPES.DATE, dateValidationSchema), _constants.OPTIONS_CONTROLS_TYPES.PHONE, phoneValidationSchema), _constants.OPTIONS_CONTROLS_TYPES.TEXTAREA, textValidationSchema);
var DEFAULT_OPTION_VALUE = '';
var getOptionKey = exports.getOptionKey = function getOptionKey(type, value) {
  return "".concat(type, "-").concat(value);
};
var mapOptionsToValues = exports.mapOptionsToValues = R.pipe(R.map(function (_ref5) {
  var value = _ref5.value,
    _ref5$props = _ref5.props,
    type = _ref5$props.type,
    initialActive = _ref5$props.initialActive;
  return [getOptionKey(type, value), R.equals(type, _constants.OPTIONS_CONTROLS_TYPES.CHECKBOX) ? initialActive : DEFAULT_OPTION_VALUE];
}), R.fromPairs);
var generateOptionsValidators = exports.generateOptionsValidators = R.pipe(R.map(function (_ref6) {
  var value = _ref6.value,
    _ref6$props = _ref6.props,
    required = _ref6$props.required,
    type = _ref6$props.type;
  return [getOptionKey(type, value), OPTIONS_CONTROLS_VALIDATORS[type](required)];
}), R.fromPairs);
var getOptionsSchema = exports.getOptionsSchema = function getOptionsSchema(options) {
  return (0, _yup.object)().shape(generateOptionsValidators(options));
};
var createPassportTouchedEntity = exports.createPassportTouchedEntity = function createPassportTouchedEntity(passportFields) {
  return R.map(function (key) {
    return [key, true];
  }, passportFields);
};